<tpm-card class="contentful-list-card">
  <div class="contentful-list-item" [class.mobile]="isMobileView" (click)="data.actions ? null : listItemClick.emit()">
    <mat-icon *ngIf="!data.image; else image" class="contentful-list-item__icon" [fontIcon]="data.icon"></mat-icon>
    <ng-template #image>
      <img class="contentful-list-item__icon image" [src]="data.image" />
    </ng-template>
    <div class="contentful-list-item__content">
      <div class="contentful-list-item__content__overline cta-sm">
        <span>{{ data.overline }}</span>
        <span *ngIf="data.date">&nbsp;&ndash;&nbsp;{{ data.date | date : "dd.MM.yyyy" }}</span>
        <tpm-colored-badge
          *ngIf="data.isNew"
          data-cy="new-badge"
          class="new-badge"
          text="Neu"
          [backgroundColor]="'--kp-color-blue-50'"
          [color]="'--kp-color-blue-700'"
        ></tpm-colored-badge>
        <mat-icon *ngIf="data.checkCritical" class="critical-badge" fontIcon="ec_warning"></mat-icon>
      </div>
      <div class="h5">
        {{ data.headline }}
      </div>
      <div class="body-sm" [innerHTML]="data.infotext"></div>
      <div *ngIf="data.actions" class="contentful-list-item__content__actions">
        <tpm-button
          *ngFor="let action of data.actions; trackBy: trackByIndex"
          button-link
          data-cy="news-action-button"
          iconRight="gpi-chevron-right"
          (click)="listItemClick.emit(action)"
        >
          {{ action.label }}
        </tpm-button>
      </div>
    </div>
  </div>
</tpm-card>
